import React, { useState, useEffect, useContext, useRef } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Input,
  Button,
  Alert,
  CardTitle,
  CustomInput,
  FormText,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import Select from 'react-select';
import axios from 'axios';
import { getCookie } from '../../jwt/_helpers/cookie';
import TenantContext from '../../utils/tenantContext';
import { StateContext } from '../../utils/context';
import LoaderInner from '../../components/LoaderInner';
import BrandingPreview from './brandingPreview';
import LoginPreview from './loginPreview';
import formValidation from '../../validations/es6/core/Core';
import { Link } from 'react-router-dom';
import { opt } from './brandingConfigOpt';
import './brandingConfig.css';

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const THEME_COLOR = process.env.REACT_APP_BRANDING_THEME_COLOR;
const FONT_FAMILY = process.env.REACT_APP_BRANDING_FONT_FAMILY;

const fontOptions = [
  { value: 'Agdasima, sans-serif', label: 'Agdasima' },
  { value: 'Alatsi, sans-serif', label: 'Alatsi' },
  { value: 'Alegreya Sans, sans-serif', label: 'Alegreya Sans' },
  { value: 'Almarai, sans-serif', label: 'Almarai' },
  { value: 'Anonymous Pro, monospace', label: 'Anonymous Pro' },
  { value: 'Arsenal, sans-serif', label: 'Arsenal' },
  { value: 'Arsenal SC, sans-serif', label: 'Arsenal SC' },
  { value: 'Arya, sans-serif', label: 'Arya' },
  { value: 'Asap Condensed, sans-serif', label: 'Asap Condensed' },
  { value: 'Asul, serif', label: 'Asul' },
  { value: 'Average Sans, sans-serif', label: 'Average Sans' },
  { value: 'Bai Jamjuree, sans-serif', label: 'Bai Jamjuree' },
  { value: 'Blinker, sans-serif', label: 'Blinker' },
  { value: 'Boldonse, sans-serif', label: 'Boldonse' },
  { value: 'Cabin Condensed, sans-serif', label: 'Cabin Condensed' },
  { value: 'Cal Sans, sans-serif', label: 'Cal Sans' },
  { value: 'Cambay, sans-serif', label: 'Cambay' },
  { value: 'Cantarell, sans-serif', label: 'Cantarell' },
  { value: 'Carrois Gothic, sans-serif', label: 'Carrois Gothic' },
  { value: 'Chocolate Classical Sans, sans-serif', label: 'Chocolate Classical Sans' },
  { value: 'Dhurjati, sans-serif', label: 'Dhurjati' },
  { value: 'Didact Gothic, sans-serif', label: 'Didact Gothic' },
  { value: 'DM Sans, sans-serif', label: 'DM Sans' },
  { value: 'Duru Sans, sans-serif', label: 'Duru Sans' },
  { value: 'Encode Sans Condensed, sans-serif', label: 'Encode Sans Condensed' },
  { value: 'Encode Sans Expanded, sans-serif', label: 'Encode Sans Expanded' },
  { value: 'Encode Sans Semi Condensed, sans-serif', label: 'Encode Sans Semi Condensed' },
  { value: 'Encode Sans Semi Expanded, sans-serif', label: 'Encode Sans Semi Expanded' },
  { value: 'Fira Sans, sans-serif', label: 'Fira Sans' },
  { value: 'Fragment Mono, monospace', label: 'Fragment Mono' },
  { value: 'Francois One, sans-serif', label: 'Francois One' },
  { value: 'Gafata, sans-serif', label: 'Gafata' },
  { value: 'GFS Neohellenic, sans-serif', label: 'GFS Neohellenic' },
  { value: 'Gidole, sans-serif', label: 'Gidole' },
  { value: 'Gidugu, sans-serif', label: 'Gidugu' },
  { value: 'Gowun Dodum, sans-serif', label: 'Gowun Dodum' },
  { value: 'Gruppo, sans-serif', label: 'Gruppo' },
  { value: 'Gudea, sans-serif', label: 'Gudea' },
  { value: 'Hedvig Letters Sans, sans-serif', label: 'Hedvig Letters Sans' },
  { value: 'Hind, sans-serif', label: 'Hind' },
  { value: 'Hind Guntur, sans-serif', label: 'Hind Guntur' },
  { value: 'Hind Madurai, sans-serif', label: 'Hind Madurai' },
  { value: 'Hind Mysuru, sans-serif', label: 'Hind Mysuru' },
  { value: 'Hind Siliguri, sans-serif', label: 'Hind Siliguri' },
  { value: 'Hind Vadodara, sans-serif', label: 'Hind Vadodara' },
  { value: 'IBM Plex Sans Condensed, sans-serif', label: 'IBM Plex Sans Condensed' },
  { value: 'IBM Plex Sans Devanagari, sans-serif', label: 'IBM Plex Sans Devanagari' },
  { value: 'Inria Sans, sans-serif', label: 'Inria Sans' },
  { value: 'Inter, sans-serif', label: 'Inter' },
  { value: 'Istok Web, sans-serif', label: 'Istok Web' },
  { value: 'Jost, sans-serif', label: 'Jost' },
  { value: 'Kanit, sans-serif', label: 'Kanit' },
  { value: 'Lato, sans-serif', label: 'Lato' },
  { value: 'Liter, sans-serif', label: 'Liter' },
  { value: 'Livvic, sans-serif', label: 'Livvic' },
  { value: 'Lunasima, sans-serif', label: 'Lunasima' },
  { value: 'Magra, sans-serif', label: 'Magra' },
  { value: 'Mallanna, sans-serif', label: 'Mallanna' },
  { value: 'Mandali, sans-serif', label: 'Mandali' },
  { value: 'Manjari, sans-serif', label: 'Manjari' },
  { value: 'Manrope, sans-serif', label: 'Manrope' },
  { value: 'Martel Sans, sans-serif', label: 'Martel Sans' },
  { value: 'Mingzat, sans-serif', label: 'Mingzat' },
  { value: 'Montserrat, sans-serif', label: 'Montserrat' },
  { value: 'Mukta, sans-serif', label: 'Mukta' },
  { value: 'Mulish, sans-serif', label: 'Mulish' },
  { value: 'Nanum Gothic, sans-serif', label: 'Nanum Gothic' },
  { value: 'News Cycle, sans-serif', label: 'News Cycle' },
  { value: 'Niramit, sans-serif', label: 'Niramit' },
  { value: 'Nobile, sans-serif', label: 'Nobile' },
  { value: 'Noto Sans, sans-serif', label: 'Noto Sans' },
  { value: 'Noto Sans Cypro Minoan, sans-serif', label: 'Noto Sans Cypro Minoan' },
  { value: 'Noto Sans Indic Siyaq Numbers, sans-serif', label: 'Noto Sans Indic Siyaq Numbers' },
  { value: 'Noto Sans Math, sans-serif', label: 'Noto Sans Math' },
  { value: 'Noto Sans Mayan Numerals, sans-serif', label: 'Noto Sans Mayan Numerals' },
  { value: 'Noto Sans SignWriting, sans-serif', label: 'Noto Sans SignWriting' },
  { value: 'Numans, sans-serif', label: 'Numans' },
  { value: 'Nunito Sans, sans-serif', label: 'Nunito Sans' },
  { value: 'Open Sans, sans-serif', label: 'Open Sans' },
  { value: 'Orienta, sans-serif', label: 'Orienta' },
  { value: 'Oswald, sans-serif', label: 'Oswald' },
  { value: 'Overpass, sans-serif', label: 'Overpass' },
  { value: 'Oxygen, sans-serif', label: 'Oxygen' },
  { value: 'Padauk, sans-serif', label: 'Padauk' },
  { value: 'Palanquin, sans-serif', label: 'Palanquin' },
  { value: 'Pavanam, sans-serif', label: 'Pavanam' },
  { value: 'Philosopher, sans-serif', label: 'Philosopher' },
  { value: 'Play, sans-serif', label: 'Play' },
  { value: 'Poiret One, sans-serif', label: 'Poiret One' },
  { value: 'Poppins, sans-serif', label: 'Poppins' },
  { value: 'Pragati Narrow, sans-serif', label: 'Pragati Narrow' },
  { value: 'Prompt, sans-serif', label: 'Prompt' },
  { value: 'Proza Libre, sans-serif', label: 'Proza Libre' },
  { value: 'PT Sans, sans-serif', label: 'PT Sans' },
  { value: 'PT Sans Caption, sans-serif', label: 'PT Sans Caption' },
  { value: 'PT Sans Narrow, sans-serif', label: 'PT Sans Narrow' },
  { value: 'Puritan, sans-serif', label: 'Puritan' },
  { value: 'Questrial, sans-serif', label: 'Questrial' },
  { value: 'Ramabhadra, sans-serif', label: 'Ramabhadra' },
  { value: 'Rambla, sans-serif', label: 'Rambla' },
  { value: 'Roboto, sans-serif', label: 'Roboto' },
  { value: 'Ropa Sans, sans-serif', label: 'Ropa Sans' },
  { value: 'Rubik, sans-serif', label: 'Rubik' },
  { value: 'Sansation, sans-serif', label: 'Sansation' },
  { value: 'Saira, sans-serif', label: 'Saira' },
  { value: 'Sarabun, sans-serif', label: 'Sarabun' },
  { value: 'Sarala, sans-serif', label: 'Sarala' },
  { value: 'Shippori Antique, sans-serif', label: 'Shippori Antique' },
  { value: 'Shippori Antique B1, sans-serif', label: 'Shippori Antique B1' },
  { value: 'Sintony, sans-serif', label: 'Sintony' },
  { value: 'Source Sans 3, sans-serif', label: 'Source Sans 3' },
  { value: 'Space Mono, monospace', label: 'Space Mono' },
  { value: 'Special Gothic Condensed One, sans-serif', label: 'Special Gothic Condensed One' },
  { value: 'Special Gothic Expanded One, sans-serif', label: 'Special Gothic Expanded One' },
  { value: 'Spinnaker, sans-serif', label: 'Spinnaker' },
  { value: 'Strait, sans-serif', label: 'Strait' },
  { value: 'Sunflower, sans-serif', label: 'Sunflower' },
  { value: 'Tajawal, sans-serif', label: 'Tajawal' },
  { value: 'Tauri, sans-serif', label: 'Tauri' },
  { value: 'Telex, sans-serif', label: 'Telex' },
  { value: 'Tenali Ramakrishna, sans-serif', label: 'Tenali Ramakrishna' },
  { value: 'Thasadith, sans-serif', label: 'Thasadith' },
  { value: 'Timmana, sans-serif', label: 'Timmana' },
  { value: 'Tinos, serif', label: 'Tinos' },
  { value: 'Titillium Web, sans-serif', label: 'Titillium Web' },
  { value: 'Tomorrow, sans-serif', label: 'Tomorrow' },
  { value: 'Tuffy, sans-serif', label: 'Tuffy' },
  { value: 'Ubuntu, sans-serif', label: 'Ubuntu' },
  { value: 'Ubuntu Condensed, sans-serif', label: 'Ubuntu Condensed' },
  { value: 'Varela, sans-serif', label: 'Varela' },
  { value: 'Varela Round, sans-serif', label: 'Varela Round' },
  { value: 'Voces, sans-serif', label: 'Voces' },
  { value: 'Voltaire, sans-serif', label: 'Voltaire' },
  { value: 'Work Sans, sans-serif', label: 'Work Sans' },
  { value: 'Yantramanav, sans-serif', label: 'Yantramanav' },
  { value: 'Zen Kaku Gothic Antique, sans-serif', label: 'Zen Kaku Gothic Antique' },
  { value: 'Zen Kaku Gothic New, sans-serif', label: 'Zen Kaku Gothic New' },
  { value: 'Zen Maru Gothic, sans-serif', label: 'Zen Maru Gothic' },
];

const loginFormAlignmentOptions = [
  { value: 'right', label: 'Right' },
  { value: 'center', label: 'Center' },
  { value: 'left', label: 'Left' },
];

const loadGoogleFont = (fontFamilyValue) => {
  try {
    const raw = (fontFamilyValue || '').split(',')[0].replace(/['"]/g, '').trim();
    if (!raw) return;
    const id = `gf-${raw.replace(/\s+/g, '-')}`;
    if (document.getElementById(id)) return;
    const urlFamily = `${raw.replace(/\s+/g, '+')}:wght@300;400;500;600;700`;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${urlFamily}&display=swap`;
    document.head.appendChild(link);
  } catch (e) {}
};

const isAbsoluteHttpUrl = (url) => /^https?:\/\//i.test(url || '');

const toFullLogoUrl = (maybeRelative) => {
  if (!maybeRelative) return '';
  if (isAbsoluteHttpUrl(maybeRelative)) return maybeRelative;
  const rel = (maybeRelative || '').replace(/^\//, '');
  return `${API_URL}${rel}`;
};

const toRelativeLogoPath = (maybeFull) => {
  if (!maybeFull) return '';
  if (maybeFull.startsWith(API_URL)) {
    return maybeFull.replace(API_URL, '');
  }
  return maybeFull;
};

const generateRandomHex = (length) => {
  return [...Array(length)]
  .map(() => Math.floor(Math.random() * 16).toString(16))
  .join('');
};

const BrandingConfig = () => {
  const token = getCookie("token");
  const { tenant, setTenant } = useContext(TenantContext);
  const { currentUser, setCurrentUser } = useContext(StateContext);

  const [brandColor, setBrandColor] = useState(THEME_COLOR);
  const [fontFamily, setFontFamily] = useState(FONT_FAMILY);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoImgUrl, setLogoImgUrl] = useState(null);
  const [pendingLogo, setPendingLogo] = useState('');

  const [logoTopbarPreview, setLogoTopbarPreview] = useState(null);
  const [logoImgUrlTopbar, setLogoImgUrlTopbar] = useState(null);
  const [pendingLogoTopbar, setPendingLogoTopbar] = useState('');

  const [selectedFont, setSelectedFont] = useState(null);
  const [hasChanges, setHasChanges] = useState(false);
  const [availableFonts] = useState(fontOptions);
  const [companyName, setCompanyName] = useState('');
  const [companyWebsite, setCompanyWebsite] = useState('');
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState('');
  const [cookiePolicyUrl, setCookiePolicyUrl] = useState('');
  const [termsAndConditionsUrl, setTermsAndConditionsUrl] = useState('');
  const [loginFormAlignment, setLoginFormAlignment] = useState(null);
  const [loginFormDisplayLogo, setLoginFormDisplayLogo] = useState(false);
  const [slaLevel, setSlaLevel] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [noDeploymentCredits, setNoDeploymentCredits] = useState(false);
  const [deploymentInProgress, setDeploymentInProgress] = useState(false);

  const fvRef = useRef();

  useEffect(() => {
    if (currentUser && currentUser.sla_level) {
      setSlaLevel(currentUser.sla_level || null);
    }
    if (currentUser && currentUser.deployment_credits <= 0) {
      setNoDeploymentCredits(true);
    }
    if (currentUser && currentUser.last_branding_updated ) {
      const lastBrandingUpdate = new Date(currentUser.last_branding_updated);
      const now = new Date();
      const diffTime = Math.abs(now - lastBrandingUpdate);
      const diffMinutes = Math.ceil(diffTime / (1000 * 60));
      if (diffMinutes <= 15) {
        setDeploymentInProgress(true);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    if (tenant && tenant.branding) {
      const tenantLogo = tenant.branding.logo || '';
      const tenantLogoTopbar = tenant.branding.logo_topbar_fe || '';
      const tenantPrimaryColor = tenant.branding.first_color || THEME_COLOR;
      const tenantFontFamily = tenant.branding.font_family_fe || FONT_FAMILY;
      const fontOption = (availableFonts || []).find(option => option.value === tenantFontFamily);

      setCompanyName(tenant.branding?.company || '');
      setCompanyWebsite(tenant.branding?.website || '');

      setSelectedFont(fontOption || (availableFonts && availableFonts[0]) || null);

      const relativeLogo = toRelativeLogoPath(tenantLogo);
      const relativeLogoTopbar = toRelativeLogoPath(tenantLogoTopbar);
      setPendingLogo(relativeLogo);
      setLogoImgUrl(toFullLogoUrl(relativeLogo));
      setPendingLogoTopbar(relativeLogoTopbar);
      setLogoImgUrlTopbar(toFullLogoUrl(relativeLogoTopbar));
      setBrandColor(tenantPrimaryColor);
      setFontFamily(tenantFontFamily);
      loadGoogleFont(tenantFontFamily);
    }
    if (tenant) {
      setPrivacyPolicyUrl(tenant.privacy_policy_url || '');
      setCookiePolicyUrl(tenant.cookie_policy_url || '');
      setTermsAndConditionsUrl(tenant.terms_and_conditions_url || '');
    }

    if (slaLevel && tenant && tenant.branding) {
      if (slaLevel === "Standard" || slaLevel === "Business Lite") {
        if (slaLevel === "Standard") {
          setLoginFormDisplayLogo(false);
          setLoginFormAlignment("center");
        }
        else if (slaLevel === "Business Lite") {
          setLoginFormDisplayLogo(tenant.branding.display_logo || true);
          setLoginFormAlignment("center");
        }
      }
      else {
        setLoginFormDisplayLogo(tenant.branding.display_logo || true);
        setLoginFormAlignment(tenant.branding.form_alignment_fe || null);
      }
    }
  }, [tenant, availableFonts, slaLevel]);

  useEffect(() => {
    const formEl = document.getElementById('brandingForm');
    if (!formEl) return;

    const fv = formValidation(formEl, opt);
    fvRef.current = fv;

    return () => {
      if (fvRef.current && fvRef.current.destroy) {
        fvRef.current.destroy();
        fvRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (logoPreview) {
      try {
        const objectUrl = URL.createObjectURL(logoPreview);
        setLogoImgUrl(objectUrl);
      } catch (e) {}
    }
  }, [logoPreview]);


  useEffect(() => {
    if (logoTopbarPreview) {
      try {
        const objectUrl = URL.createObjectURL(logoTopbarPreview);
        setLogoImgUrlTopbar(objectUrl);
      } catch (e) {}
    }
  }, [logoTopbarPreview]);

  useEffect(() => {
    const initialLogo = toRelativeLogoPath(tenant?.branding?.logo || '');
    const initialLogoTopbar = toRelativeLogoPath(tenant?.branding?.logo_topbar_fe || '');
    const initialColor = tenant?.branding?.first_color || THEME_COLOR;
    const initialFont = tenant?.branding?.font_family_fe || FONT_FAMILY;
    const initialLoginFormAlignment = tenant?.branding?.form_alignment_fe || null;
    const initialLoginFormDisplayLogo = tenant?.branding?.logo_visible_fe || false;
    const initialCompanyName = tenant?.company || '';
    const initialCompanyWebsite = tenant?.website || '';
    const initialPrivacyPolicyUrl = tenant?.privacy_policy_url || '';
    const initialCookiePolicyUrl = tenant?.cookie_policy_url || '';
    const initialTermsAndConditionsUrl = tenant?.terms_and_conditions_url || '';

    const changed =
      ((pendingLogo && pendingLogo !== initialLogo)) ||
      (pendingLogoTopbar && pendingLogoTopbar !== initialLogoTopbar) ||
      (brandColor && brandColor !== initialColor) ||
      (fontFamily && fontFamily !== initialFont) ||
      (loginFormAlignment !== initialLoginFormAlignment) ||
      (loginFormDisplayLogo !== initialLoginFormDisplayLogo) ||
      (companyName !== initialCompanyName) ||
      (companyWebsite !== initialCompanyWebsite) ||
      (privacyPolicyUrl !== initialPrivacyPolicyUrl) ||
      (cookiePolicyUrl !== initialCookiePolicyUrl) ||
      (termsAndConditionsUrl !== initialTermsAndConditionsUrl);

    setHasChanges(!!changed);
  }, [pendingLogo, pendingLogoTopbar, brandColor, fontFamily, loginFormAlignment, loginFormDisplayLogo, companyName, companyWebsite, privacyPolicyUrl, cookiePolicyUrl, termsAndConditionsUrl, tenant]);

  const handleLogoUpload = (file, kind) => {
    if (!file) return;

    if (kind === 'logo') {
      setLogoPreview(file);
    } else {
      setLogoTopbarPreview(file);
    }

    let uploadDestination = kind === 'logo' ? 'tenant_logos' : 'tenant_logos_fe';

    setLoading(true);
    let fileParts = file.name;
    let fileType = fileParts.split('.')[1];
    let fileName = generateRandomHex(10);

    axios({
      method: "GET",
      mode: 'cors',
      url: `${API_URL}obtain-signed-url-for-upload/?filename=media/${uploadDestination}/${fileName}.${fileType}&filetype=${fileType}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": X_API_KEY,
      }
    }).then(function(response) {
      const URL = response.data.signed_url.url;
      const full_URL = response.data.signed_url.fields.key;
      let split = (full_URL || '').split('/');
      split.shift();
      let transformedURL = split.join('/');

      const signedOpts = response.data.signed_url.fields;
      var options = {
        mode: 'cors',
        headers: {
          "Content-Type": fileType
        }
      };
      var postData = new FormData();
      for (let i in signedOpts) {
        postData.append(i, signedOpts[i]);
      }
      postData.append("file", file);

      axios
        .post(URL, postData, options)
        .then(result => {
          const relative = toRelativeLogoPath(transformedURL);
          if (kind === 'logo') {
            setPendingLogo(relative);
          } else {
            setPendingLogoTopbar(relative);
          }
          setLoading(false);
        })
        .catch(error => {
          console.log("ERROR " + error);
          setError(true);
          setLoading(false);
        });
    }).catch(error => {
      console.log("ERROR " + error);
      setError(true);
      setLoading(false);
    });
  };

  const handleColorChange = (color) => {
    setBrandColor(color.hex);
  };

  const handleSave = () => {
    if (fvRef.current && fvRef.current.validate) {
      fvRef.current.validate().then((status) => {
        if (status === 'Valid') {
          setConfirmModalOpen(true);
        }
      });
    } else {
      setConfirmModalOpen(true);
    }
  };

  const performSave = () => {
    setConfirmModalOpen(false);
    setLoading(true);

    const initialLogo = toRelativeLogoPath(tenant?.branding?.logo || '');
    const initialLogoTopbar = toRelativeLogoPath(tenant?.branding?.logo_topbar_fe || '');
    const initialColor = tenant?.branding?.first_color || THEME_COLOR;
    const initialFont = tenant?.branding?.font_family_fe || FONT_FAMILY;
    const initialCompanyName = tenant?.branding?.company || '';
    const initialCompanyWebsite = tenant?.branding?.website || '';

    const initialLoginFormAlignment = tenant?.branding?.form_alignment_fe || null;
    const initialLoginFormDisplayLogo = tenant?.branding?.logo_visible_fe || false;

    const initialPrivacyPolicyUrl = tenant?.privacy_policy_url || '';
    const initialCookiePolicyUrl = tenant?.cookie_policy_url || '';
    const initialTermsAndConditionsUrl = tenant?.terms_and_conditions_url || '';

    const updateData = {};
    const brandingUpdates = {};
    if (pendingLogo && pendingLogo !== initialLogo) {
      brandingUpdates.logo = toRelativeLogoPath(pendingLogo);
    }
    if (pendingLogoTopbar && pendingLogoTopbar !== initialLogoTopbar) {
      brandingUpdates.logo_topbar_fe = toRelativeLogoPath(pendingLogoTopbar);
    }
    if (brandColor && brandColor !== initialColor) {
      brandingUpdates.first_color = brandColor;
    }
    if (fontFamily && fontFamily !== initialFont) {
      brandingUpdates.font_family_fe = fontFamily;
    }
    if (companyName !== initialCompanyName) {
      brandingUpdates.company = companyName;
    }
    if (companyWebsite !== initialCompanyWebsite) {
      brandingUpdates.website = companyWebsite;
    }
    if (loginFormAlignment !== initialLoginFormAlignment) {
      brandingUpdates.form_alignment_fe = loginFormAlignment;
    }
    if (loginFormDisplayLogo !== initialLoginFormDisplayLogo) {
      brandingUpdates.logo_visible_fe = loginFormDisplayLogo;
    }
    if (Object.keys(brandingUpdates).length > 0) {
      updateData.branding = brandingUpdates;
    }
    if (privacyPolicyUrl !== initialPrivacyPolicyUrl) {
      updateData.privacy_policy_url = privacyPolicyUrl;
    }
    if (cookiePolicyUrl !== initialCookiePolicyUrl) {
      updateData.cookie_policy_url = cookiePolicyUrl;
    }
    if (termsAndConditionsUrl !== initialTermsAndConditionsUrl) {
      updateData.terms_and_conditions_url = termsAndConditionsUrl;
    }

    if(slaLevel !== "gold" && tenant.google_oauth) {
      updateData.google_oauth = false;
    }

    if (Object.keys(updateData).length === 0) {
      setLoading(false);
      return;
    }

    axios({
      method: "POST",
      url: `${API_URL}tenant-branding-update/`,
      data: updateData,
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": X_API_KEY,
      }
    }).then(function(response) {
      if (response.status === 200) {
        axios(
          {
          method: "GET",
          mode: 'cors',
          url: `${API_URL}tenants/`,
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": X_API_KEY,
          }
        }).then(function(response) {
          if (response.status === 200) {
            setTenant(response.data);
            const updatedRelLogo = toRelativeLogoPath(response.data?.branding?.logo || '');
            setLogoImgUrl(updatedRelLogo ? toFullLogoUrl(updatedRelLogo) : null);
            const updatedRelLogoTopbar = toRelativeLogoPath(response.data?.branding?.logo_topbar_fe || '');
            setLogoImgUrlTopbar(updatedRelLogoTopbar ? toFullLogoUrl(updatedRelLogoTopbar) : null);
            setHasChanges(false);
            axios({
              method: "GET",
              url: `${API_URL}users/${currentUser.id}/`,
              mode: 'cors',
              headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": X_API_KEY,
              }
            }).then(response => {
              if (response.status === 200) {
                setCurrentUser(response.data);
              }
            });
          }
          setSuccess(true);
          setLoading(false);
          // setTimeout(() => setSuccess(false), 5000);
        });
      } else {
        setError(true);
        setLoading(false);
        // setTimeout(() => setError(false), 5000);
      }
    }).catch(error => {
      console.log("ERROR " + error);
      setError(true);
      setLoading(false);
      // setTimeout(() => setError(false), 5000);
    });
  };

  const handleReset = () => {
    setBrandColor(THEME_COLOR);
    setFontFamily(FONT_FAMILY);
    setLogoPreview('');
    setLogoTopbarPreview('');
    setPendingLogo('');
    setPendingLogoTopbar('');
    setSelectedFont((availableFonts && availableFonts[0]) || null);
    setCompanyName(tenant?.branding?.company || '');
    setCompanyWebsite(tenant?.branding?.website || '');
    setPrivacyPolicyUrl(tenant?.privacy_policy_url || '');
    setCookiePolicyUrl(tenant?.cookie_policy_url || '');
    setTermsAndConditionsUrl(tenant?.terms_and_conditions_url || '');

    if (slaLevel && tenant && tenant.branding) {
      if (slaLevel === "Standard" || slaLevel === "Business Lite") {
        if (slaLevel === "Standard") {
          setLoginFormDisplayLogo(false);
          setLoginFormAlignment("center");
        }
        else if (slaLevel === "Business Lite") {
          setLoginFormDisplayLogo(tenant.branding.display_logo || true);
          setLoginFormAlignment("center");
        }
      }
      else {
        setLoginFormDisplayLogo(tenant.branding.display_logo || true);
        setLoginFormAlignment(tenant.branding.form_alignment_fe || null);
      }
    }
  };

  return (
    <div className="container-fluid branding-container">
      <LoaderInner show={loading} />
      {
        noDeploymentCredits && (
          <Alert color="danger">
            You do not have any deployment credits to update the branding. Please <a href="/deployment-credits/order">purchase deployment credits</a> in order to update the branding.
          </Alert>
        )
      }
      {
        deploymentInProgress && (
          <Alert color="info">
            A branding update is in progress. Please wait for it to complete. It usually takes upto 15 minutes.
          </Alert>
        )
      }
      <Row>
        <Col sm={12}>
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Brand Configuration</CardTitle>
              <p className="text-muted">Customize app appearance.</p>
            </CardHeader>
            <CardBody>
              <Form id="brandingForm">
                <Row className="mb-4 branding-section">
                  <Col sm={12} md={6} lg={6} xl={6}>
                    <h5>Logo (Topbar)</h5>
                    <FormGroup>
                      <CustomInput
                        type="file"
                        id="logoTopbar"
                        name="logoTopbar"
                        accept=".png"
                        onChange={(e) => handleLogoUpload(e.target.files[0], 'logoTopbar')}
                        disabled={loading}
                      />
                      <small className="text-muted">
                        Recommended size: 200x60px. Supported format: PNG<br/>
                        <strong>Note:</strong> This logo is used on the topbar of the app please choose matching logo color with the primary color for best visibility.
                      </small>
                    </FormGroup>
                    
                    {logoImgUrlTopbar && (
                      <div className="mt-3">
                        <div className="logo-preview" style={{ maxWidth: '200px', "--theme-color": brandColor }}>
                          <img 
                            src={logoImgUrlTopbar} 
                            alt="Logo preview" 
                            style={{ maxWidth: '100%', height: 'auto'}}
                            onError={(e) => {
                              console.error('Logo preview failed to load:', logoImgUrlTopbar);
                              e.target.style.display = 'none';
                            }}
                            onLoad={() => {
                              console.log('Logo preview loaded successfully:', logoImgUrlTopbar);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </Col>

                  <Col sm={12} md={6} lg={6} xl={6}>
                    <h5>Logo (Email and Login)</h5>
                    <FormGroup>
                      <CustomInput
                        type="file"
                        id="logo"
                        name="logo"
                        accept=".png"
                        onChange={(e) => handleLogoUpload(e.target.files[0], 'logo')}
                        disabled={loading}
                      />
                      <small className="text-muted">
                        Recommended size: 200x60px. Supported format: PNG<br/>
                        <strong>Note:</strong> This logo is used on the login form and email on white background please choose a logo with dark colors and trasparent background.
                      </small>
                    </FormGroup>
                    
                    {logoImgUrl && (
                      <div className="mt-3">
                        <div className="logo-preview" style={{ maxWidth: '200px', "--theme-color": brandColor }}>
                          <img 
                            src={logoImgUrl} 
                            alt="Logo preview" 
                            style={{ maxWidth: '100%', height: 'auto'}}
                            onError={(e) => {
                              console.error('Logo preview failed to load:', logoImgUrl);
                              e.target.style.display = 'none';
                            }}
                            onLoad={() => {
                              console.log('Logo preview loaded successfully:', logoImgUrl);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </Col>

                  <Col sm={12} md={6} lg={6} xl={6} className="mt-3">
                    <h5>Primary Color</h5>
                    <FormGroup>
                      <div className="color-picker-container" style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          className="color-swatch"
                          style={{
                            backgroundColor: brandColor
                          }}
                          onClick={() => setShowColorPicker(!showColorPicker)}
                        />
                        <Input
                          type="text"
                          name="brandColor"
                          pattern="#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})"
                          value={brandColor}
                          onChange={(e) => {
                            setBrandColor(e.target.value);
                            handleColorChange({ hex: e.target.value });
                            if (fvRef.current && fvRef.current.revalidateField) {
                              setTimeout(() => {
                                if (fvRef.current) {
                                  fvRef.current.revalidateField('brandColor');
                                }
                              }, 0);
                            }
                          }}
                          placeholder={THEME_COLOR}
                          style={{ flex: 1, minWidth: 0, marginLeft: '12px' }}
                        />
                      </div>
                      {showColorPicker && (
                        <div className="mt-3">
                          <Input
                            type="color"
                            value={brandColor}
                            onChange={(e) => {
                              setBrandColor(e.target.value);
                              handleColorChange({ hex: e.target.value });
                              if (fvRef.current && fvRef.current.revalidateField) {
                                setTimeout(() => {
                                  if (fvRef.current) {
                                    fvRef.current.revalidateField('brandColor');
                                  }
                                }, 0);
                              }
                            }}
                            style={{ width: '100px', height: '40px' }}
                          />
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  
                  <Col sm={12} md={6} lg={6} xl={6} className="mt-3">
                    <h5>Font Family</h5>
                    <FormGroup style={{ marginTop: '20px' }}>
                      <Select
                        components={{ IndicatorSeparator:() => null }}
                        name="fontFamily"
                        id="fontFamily"
                        options={availableFonts}
                        value={selectedFont}
                        onChange={(selectedOption) => {
                          setSelectedFont(selectedOption);
                          setFontFamily(selectedOption.value);
                          loadGoogleFont(selectedOption.value);
                        }}
                        placeholder="Select a font..."
                        isSearchable
                        maxMenuHeight={320}
                      />
                      {/* <div className="mt-5">
                      <h5>Font Preview</h5>
                        <div 
                          className="font-preview"
                          style={{
                            fontFamily: fontFamily,
                            color: brandColor,
                            "--theme-color": brandColor,
                          }}
                        >
                          <div>
                            <h3 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: '600' }}>
                              {tenant?.name || 'Your Brand Name'}
                            </h3>
                            <p style={{ margin: '0 0 4px 0', fontSize: '16px', opacity: '0.9' }}>
                              The quick brown fox jumps over the lazy dog
                            </p>
                            <p style={{ margin: '0', fontSize: '14px', opacity: '0.7' }}>
                              ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789
                            </p>
                          </div>
                        </div>
                      </div> */}
                    </FormGroup>
                  </Col>

                  <Col sm={12} md={6} lg={6} xl={6} className="mt-3 mb-3">
                    <h5>Login Form Alignment</h5>
                    <Select
                      id="loginFormAlignment"
                      value={loginFormAlignmentOptions.find(option => option.value === loginFormAlignment) || null}
                      options={loginFormAlignmentOptions}
                      onChange={(selectedOption) => setLoginFormAlignment(selectedOption.value)}
                      components={{ IndicatorSeparator:() => null }}
                      style={{ width: '100%' }}
                      isDisabled={slaLevel === "Standard" || slaLevel === "Business Lite"}
                    />
                    {(slaLevel === "Standard" || slaLevel === "Business Lite") && (
                    <FormText color="muted">
                        This feature is not available in your current <Link to="/sla">SLA level</Link>. Please <Link to="/sla">upgrade</Link> to a higher <Link to="/sla">SLA level</Link> to use this feature.
                    </FormText>
                    )}
                  </Col>

                  <Col sm={12} md={6} lg={6} xl={6} className="mt-3 mb-3">
                    <h5>Login Form (Logo Visible)</h5>
                    <CustomInput
                      type="checkbox"
                      id="loginFormDisplayLogo"
                      checked={loginFormDisplayLogo}
                      onChange={(e) => setLoginFormDisplayLogo(!!e.target.checked)}
                      disabled={slaLevel === "Standard"}
                    />
                    {(slaLevel === "Standard") && (
                      <FormText color="muted">
                        This feature is not available in your current <Link to="/sla">SLA level</Link>. Please <Link to="/sla">upgrade</Link> to a higher <Link to="/sla">SLA level</Link> to use this feature.
                      </FormText>
                    )}
                  </Col>

                  <Col sm={12}>
                    <h5>Preview</h5>
                    <Row>
                      <Col md={6} sm={12} className="mb-3">
                        <h6 className="text-muted" style={{ marginBottom: '8px' }}>App Preview</h6>
                        <BrandingPreview
                          brandColor={brandColor}
                          fontFamily={fontFamily}
                          logoUrl={logoImgUrlTopbar}
                          companyName={companyName}
                          companyWebsite={companyWebsite}
                          privacyPolicyUrl={privacyPolicyUrl}
                          termsAndConditionsUrl={termsAndConditionsUrl}
                          height={600}
                        />
                      </Col>
                      <Col md={6} sm={12} className="mb-3">
                        <h6 className="text-muted" style={{ marginBottom: '8px' }}>Login Preview</h6>
                        <LoginPreview
                          brandColor={brandColor}
                          fontFamily={fontFamily}
                          logoUrl={logoImgUrl}
                          formAlignment={loginFormAlignment}
                          displayLogo={loginFormDisplayLogo}
                          signUpEnabled={tenant.self_signup}
                          googleOAuthEnabled={(slaLevel === "gold" && tenant.google_oauth) ? true : false}
                          height={600}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className="mb-4 branding-section">
                  <Col sm={12}>
                    <h5>Company & Policies</h5>
                    <FormGroup>
                      <label htmlFor="companyName">Company Name</label>
                      <Input
                        type="text"
                        id="companyName"
                        name="companyName"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        placeholder="Your company name"
                      />
                    </FormGroup>
                    <FormGroup>
                      <label htmlFor="companyWebsite">Website</label>
                      <Input
                        type="url"
                        id="companyWebsite"
                        name="companyWebsite"
                        value={companyWebsite}
                        onChange={(e) => setCompanyWebsite(e.target.value)}
                        placeholder="https://example.com"
                      />
                    </FormGroup>
                    <FormGroup>
                      <label htmlFor="privacyPolicyUrl">Privacy Policy URL</label>
                      <Input
                        type="url"
                        id="privacyPolicyUrl"
                        name="privacyPolicyUrl"
                        value={privacyPolicyUrl}
                        onChange={(e) => setPrivacyPolicyUrl(e.target.value)}
                        placeholder="https://example.com/privacy-policy"
                      />
                    </FormGroup>
                    <FormGroup>
                      <label htmlFor="cookiePolicyUrl">Cookie Policy URL</label>
                      <Input
                        type="url"
                        id="cookiePolicyUrl"
                        name="cookiePolicyUrl"
                        value={cookiePolicyUrl}
                        onChange={(e) => setCookiePolicyUrl(e.target.value)}
                        placeholder="https://example.com/cookie-policy"
                      />
                    </FormGroup>
                    <FormGroup>
                      <label htmlFor="termsAndConditionsUrl">Terms and Conditions URL</label>
                      <Input
                        type="url"
                        id="termsAndConditionsUrl"
                        name="termsAndConditionsUrl"
                        value={termsAndConditionsUrl}
                        onChange={(e) => setTermsAndConditionsUrl(e.target.value)}
                        placeholder="https://example.com/terms-and-conditions"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {success && (
                  <Alert color="success">
                    Branding configuration updated successfully!<br/>
                    <strong>Note: Please note that it may take up to 15 minutes for the changes to take effect.</strong>
                  </Alert>
                )}
                {error && (
                  <Alert color="danger">
                    Error saving branding configuration. Please try again.
                  </Alert>
                )}

                <Row>
                  <Col sm={12}>
                    <div className="float-right">
                      <Button
                        className="btn btn-success mr-2"
                        onClick={handleSave}
                        disabled={loading || !hasChanges || success || noDeploymentCredits || deploymentInProgress}
                      >
                        Save
                      </Button>
                      <Button
                        className="btn btn-info"
                        onClick={handleReset}
                        disabled={loading || success || noDeploymentCredits || deploymentInProgress}
                      >
                        Reset
                      </Button>
                    </div>
                  </Col>
                </Row>

                {confirmModalOpen && (
                  <Modal isOpen={confirmModalOpen} centered={true}>
                    <ModalHeader>Are you sure that you want to update tenant configuration?</ModalHeader>
                    <ModalBody>
                      Please note that each update would result in deduction of <strong>1 Deployment Credit</strong>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn btn-secondary" onClick={() => setConfirmModalOpen(false)} disabled={loading}>
                        Cancel
                      </Button>
                      <Button className="btn btn-success" onClick={performSave} disabled={loading}>
                        Confirm
                      </Button>
                    </ModalFooter>
                  </Modal>
                )}
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default BrandingConfig;
